import { render, staticRenderFns } from "./SpecificationsTable.vue?vue&type=template&id=0ac0f5be"
import script from "./SpecificationsTable.vue?vue&type=script&lang=js"
export * from "./SpecificationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports